import * as React from "react";
import styled from "styled-components";
import dynamic from "next/dynamic";

import { isLocalDevelop } from "utils/debug";
import { setSentryCatchOnRequest } from "utils/sentryEvent";
import { onChangeHeaderLang } from "utils/language";
import { isNotBlankArray } from "utils/array";
import { Platform } from "utils/runtime";
import WebHeader from "./components/Header";
import { MainProps } from "../index";
import MegatronFrontForWeb from "./components/MegatronFrontForWeb";
import ErrorPage from "components/ErrorPage";

const WebFooter = dynamic(import("./components/Footer"), {
	ssr: false,
});

const MainContainer = styled.section`
	min-height: 600px;
	min-width: 1200px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
`;

const NewPageTipsDom = styled.div`
	width: 100%;
	padding: 10px;
	text-align: center;
	font-size: 16;
	color: red;
`;
export const NewPageTips = () => {
	return <NewPageTipsDom>此页面为新页面，做新老页面区分，不影响测试</NewPageTipsDom>;
};

class WebHome extends React.Component<MainProps> {
	render() {
		const { page, runtime, frontModules } = this.props;
		const isPageDisabled = !page || page.isDisable;
		const defaultProps = {
			isDev: isLocalDevelop(runtime.hostname),
			isUat: runtime.isUat,
			cookies: runtime.cookies || {},
			runtime: {
				languageCode: runtime.languageCode,
				currency: runtime.currency,
				countryCode: runtime.countryCode3,
				countryCode2: runtime.countryCode2,
				sid: runtime.sid,
				sessionKey: runtime.sessionKey,
				platform: Platform.WEB,
				multiLanImgKey: runtime.multiLanImgKey,
				countryId: runtime.countryId,
			},
		};

		return (
			<main style={{ overflowX: "hidden", fontFamily: "Avenir-Roman,sans-serif" }}>
				<WebHeader
					{...defaultProps}
					onSentryCatch={setSentryCatchOnRequest}
					onChangeLanguage={onChangeHeaderLang}
				/>
				{runtime.isUat && <NewPageTips />}
				<MainContainer
					style={{
						backgroundColor: page?.ui.bgColor || "#f7f7f7",
					}}
				>
					{isPageDisabled || !isNotBlankArray(frontModules) ? (
						<ErrorPage language={runtime.languageCode} />
					) : (
						<MegatronFrontForWeb {...this.props} />
					)}
				</MainContainer>
				<WebFooter {...defaultProps} />
			</main>
		);
	}
}

export default WebHome;
